export default __webpack_public_path__ + "static/media/one-number.e320efcd.svg";